import {
  initialNotificationsState,
  INotificationsState,
} from './notifications.state';
import {
  ENotificationsActions,
  NotificationsActions,
} from './notifications.actions';

const getNotificationsCopy = (state: INotificationsState) => {
  const stateCopy = { ...state };
  return [...stateCopy.notifications];
};

const setNotifications = (state: INotificationsState, id: number) => {
  const notificationsCopy = getNotificationsCopy(state);
  const notificationId = notificationsCopy.findIndex(
    n => n.notification.id === id
  );

  notificationsCopy.splice(notificationId, 1);

  return notificationsCopy;
};

export const notificationsReducers = (
  state = initialNotificationsState,
  action: NotificationsActions
): INotificationsState => {
  switch (action.type) {
    case ENotificationsActions.AddNotification:
      return {
        ...state,
        notifications: [...state.notifications, action.notification],
      };
    case ENotificationsActions.ReadNotifications:
      return {
        ...state,
        notifications: getNotificationsCopy(state).map(n => {
          return {
            ...n,
            notification: { ...n.notification, is_received: true },
          };
        }),
      };
    case ENotificationsActions.DeleteAllNotification:
      return {
        ...state,
        notifications: [],
      };
    case ENotificationsActions.SetNotifications:
      return {
        ...state,
        notifications: action.notifications,
      };
    case ENotificationsActions.DeleteNotificationFromState:
      return {
        ...state,
        notifications: setNotifications(state, action.id),
      };
    default:
      return state;
  }
};
